import { createFileRoute, Link } from "@tanstack/react-router";
import { RouteTopBar } from "@/components/layout/RouteTopBar";
import { LegalFooter } from "@/components/brand/LegalFooter";
import { LegalBody } from "@/components/legal/LegalBody";

export const Route = createFileRoute("/terminos")({
  head: () => ({
    meta: [
      { title: "Términos de Servicio · VerseSport™" },
      { name: "description", content: "Términos de Servicio de VerseSport™ — inteligencia deportiva en tiempo real." },
    ],
  }),
  component: TerminosPage,
});

function TerminosPage() {
  return (
    <main className="min-h-screen bg-background">
      <RouteTopBar fallback="/welcome" />
      <article className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
        <header className="mb-6">
          <h1 className="text-3xl font-black text-foreground">Términos de Servicio</h1>
          <p className="mt-1 text-xs uppercase tracking-widest text-muted-foreground">
            Última actualización: {new Date().toLocaleDateString("es")}
          </p>
        </header>
        <LegalBody variant="terms" />
        <p className="mt-8 text-xs text-muted-foreground">
          Consulta también nuestra{" "}
          <Link to="/privacidad" className="font-bold text-primary hover:underline">
            Política de Privacidad
          </Link>
          .
        </p>
        <LegalFooter />
      </article>
    </main>
  );
}